import { Button } from '@finn/design-system/atoms/button';

import { useIsFeatureVisible } from '../../../hooks/useIsFeatureVisible';
import { VisibilityConfig } from '../../../types';
import { FeatureFormField } from '../../FeatureForm';
import { MessageBanner } from '../../MessageBanner';
import { TextBlock } from '../../TextBlock';
import { DataBlock, DataBlockProps } from './DataBlock';
import { Instructions, InstructionsProps } from './Instructions';
import { ProductCardBlock } from './ProductCardBlock';
import {
  UnavailabilityBanner,
  UnavailabilityBannerProps,
} from './UnavailableBanner';

type BooleanProps = {
  type: 'boolean';
  label: string;
  name: string;
  defaultValue?: boolean;
};

type B2BInstructionsProps = {
  type: 'b2b-instructions';
  label: string;
  href: string;
};

type BannerProps = {
  type: 'banner';
  title: string;
  description: string;
};

type ProductCardProps = {
  type: 'product-card';
};

export type UniversalContentItemProps = {
  hidden?: VisibilityConfig;
} & (
  | InstructionsProps
  | BannerProps
  | B2BInstructionsProps
  | UnavailabilityBannerProps
  | DataBlockProps
  | BooleanProps
  | ProductCardProps
);

export const UniversalContentItem = (props: UniversalContentItemProps) => {
  const isHidden = useIsFeatureVisible(props.hidden || {});

  if (isHidden) {
    return null;
  }

  switch (props.type) {
    case 'instructions':
      return <Instructions {...props} />;
    case 'b2b-instructions':
      return (
        <Button
          variant="link"
          size="md"
          className="-mt-4 flex"
          href={props.href}
          target="_blank"
        >
          {props.label}
        </Button>
      );
    case 'banner': {
      return (
        <MessageBanner
          title={props.title}
          description={<TextBlock fontSize={14} text={props.description} />}
        />
      );
    }
    case 'unavailable-banner':
      return <UnavailabilityBanner {...props} />;
    case 'data-block':
      return <DataBlock {...props} />;
    case 'product-card':
      return <ProductCardBlock />;
    case 'boolean':
      return (
        <FeatureFormField
          type="boolean"
          className="[&_a]:!link-14 [&_a]:before:!hidden [&_a]:after:!hidden"
          name={props.name}
          label={props.label}
          defaultValue={props.defaultValue}
        />
      );

    default:
      return null;
  }
};
